<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
    <basic-table
      :items="DHCPLeases"
      :fields="DHCPLeasesFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      },
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        account_id: 0,
        accounting_period_id: 0
      },
      DHCPLeases: [],
      DHCPLeasesFields: [
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'user_login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'ip', label: 'IP', sortable: true},
        {key: 'mac', label: 'MAC', sortable: true},
        {key: 'relay_agent_info', label: 'Relay-Agengt info', sortable: true},
        {key: 'updated', label: this.$i18n.t('Updated'), sortable: true},
        {key: 'expired', label: this.$i18n.t('Expired'), sortable: true}
      ]
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (this.userId) {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_DHCP_LEASE', this.getStore).then(response => {
        this.DHCPLeases = this.$store.getters['Reports/DHCP_LEASE']
        for (let el of this.DHCPLeases) {
          el.updated = moment(Number(el.updated) * 1000).format('MM-DD-YYYY')
          el.expired = moment(Number(el.expired) * 1000).format('MM-DD-YYYY')
        }
        this.loadDone()
      })
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/other/dhcpLease/main.vue